import React, { useState, Fragment } from 'react';
import styles from './compare.module.scss';
import Select, {components} from 'react-select';
import {useApiData} from "../../hooks/useApiData";
import {mergeData} from "../../utils/data-utils";
import {compareData} from "../../data/data-compare";
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import { useIsMobile900 } from '../../hooks/mobile';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';
import IconDelete from '../common/icon/icon-delete';
import IconSearch from '../common/icon/icon-search';

const options = [
  { label: "Total opportunity score", value: "total" },
  { label: "Earning potential", value: "project" },
  { label: "Career advancement", value: "career" },
  { label: "Top-tier employment prospects", value: "employ" },
  { label: "Premium education", value: "edu" },
  { label: "Economic mobility", value: "econ" },
  { label: "High livability", value: "liva" },
];

const dropDownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
          <IconSearch />
      </components.DropdownIndicator>
    )
  );
};


const Compare = () => {

  const {data, isLoading, error} = useApiData();
  const [sortConfig, setSortConfig] = useState({ key: 'total', direction: 'descending' });
  
  const [passportSelected, setPassportSelected] = useState("");
  // const countryList = educ2Overview.map((c) => c.country);
  const [countrySelectedList, setCountrySelectedList] = useState([]);

  
  const isMobile = useIsMobile900();


  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const mergedData = mergeData(compareData, data);

  const sortedData = [...mergedData].sort((a, b) => {
    const aVal = a[sortConfig.key];
    const bVal = b[sortConfig.key];

    // Handle numbers
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return sortConfig.direction === 'ascending' ? aVal - bVal : bVal - aVal;
    }

    // Handle strings
    if (typeof aVal === 'string' && typeof bVal === 'string') {
      return sortConfig.direction === 'ascending'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
    }
    return 0;
  });

  const handleOptionSelect = (option) => {
    setSortConfig({ key:option.value, direction:'descending' });
  };

  const handleSort = (columnName) => {
    let direction = 'ascending';
    if (sortConfig.key === columnName && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key:columnName, direction });

  };

  const renderSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? <ReverseIconSort /> : <IconSort />;
    }
    return <IconSort />;
  };



  const passportSelectStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 100,
      backgroundColor:'#fff',
      borderRadius: 0,
      paddingLeft: 10,
      paddingRight: 10
    }),
    control: (provided) => ({
      ...provided,
      background: "transparent",
      border: "none",
      boxShadow: "none",
      borderRadius: 0,
      color: "#405363",
      padding:0,
      borderBottom: "1px solid #979797"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#405363",
      padding: isMobile ? 14 : 12,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#405363",
      fontFamily: "Garamond Regular",
      fontSize: isMobile ? 14: 16,
    //   paddingLeft: 16,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#405363",
      fontFamily: "Garamond Regular",
      fontSize: isMobile ? 14 : 16,
    //   paddingLeft: 10,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 0 8px 0",
      
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      // background: "#f7f7f7",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: isMobile ? 14 : 18,
      backgroundColor: state.isFocused
        ? "#C1C5C8"
        : state.isDisabled
        ? "#f3f3f3"
        : null,
      color: state.isFocused
        ? "#405363"
        : state.isDisabled
        ? "#405363"
        : "",
      opacity: state.isDisabled
        ? "0.5"
        : "1",
      cursor: state.isDisabled
        ? 'not-allowed'
        : 'pointer'
    }),
  };
  

  
  const getDisabledOptions = (c) => {
    return (countrySelectedList) ? countrySelectedList.includes(c) : false;
  };

  const passportOptions = () =>{
    let optionData = [];
    optionData = sortedData.sort((a, b) => a.country.localeCompare(b.country));;
    
    
    return optionData.map((t)=>({
        label: (t.im) ? t.country + '*' : t.country, 
        country: t.country, 
        value: t.total,
        // isDisabled: type === 'compare' ? getDisabledOptions().includes(passport.code) : false
        // isDisabled: getDisabledOptions().includes(t.country)
        isDisabled: getDisabledOptions(t.country)

    }));
}


  const handlePassportSelect = (selectedOption) =>{
    setPassportSelected(selectedOption);

    if(selectedOption){
      const selectedItem = sortedData.find((t) => t.country === selectedOption.country);
      
      // const selectedPassportData = sortedData.find(
      //     (d) => d.country === selectedOption.value
      // );
      const updatedList = [...countrySelectedList, selectedOption.country];
      setCountrySelectedList(updatedList);
      
      if (selectedItem) {
          // sortedData = [...sortedData, selectedItem];
          // const updatedList = countrySelectedList.push(selectedOption.country);
          // setCountrySelectedList(updatedList);
          setPassportSelected("");
      }

    }

    
  }
  
  const handlePassportSelectBlur = () =>{
    
    setPassportSelected("");
  }
  
  const handleDeleteFromTable = (country) => {
    const updatedList = countrySelectedList.filter((t) => t !== country);
    setCountrySelectedList(updatedList);
    setPassportSelected("");

  };


  
  const tableData = sortedData.filter((t) => countrySelectedList.includes(t.country));

  return (
    <>
        {/*<h2 className="mb-5">Explore How You Can Improve Your Opportunity Score via Investment Migration</h2>*/}
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`} >
        <thead>
          <tr>
            {/* <th className={styles.cityColumn} >City/Area</th> */}
            {/* <th className={styles.cityColumn} >Country</th> */}
            <th className={`${styles.selectBoxWrapper} ${styles.cityColumn}`}>
              <Select
                value={passportSelected}
                options={passportOptions()}
                onChange={handlePassportSelect}
                onBlur={handlePassportSelectBlur}
                isClearable
                isSearchable
                // menuIsOpen
                placeholder="Search for countries"
                components={{ DropdownIndicator:dropDownIndicator}}
                blurInputOnSelect={true}
                // isOptionDisabled={(option) => option.isDisabled}
                styles={passportSelectStyles}
              />
            </th>

            {/* <th
              className={`text-left ${styles.cellHideMobile} ${styles.countryColumn} ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>
                {(countryCount === 1) ? <IconSort /> : <ReverseIconSort />}
                <span className={styles.sortColumnTitleText}>Country</span>
              </div>
            </th> */}

            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.progressBarColumn}
                              ${sortConfig.key === 'total' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'total' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("total")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Total opportunity score</span>
                {renderSortArrow('total')}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortConfig.key === 'project' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'project' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("project")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Earning potential</span>
                {renderSortArrow('project')}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortConfig.key === 'career' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'career' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("career")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Career advancement</span>
                {renderSortArrow('career')}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortConfig.key === 'employ' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'employ' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("employ")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Top-tier employment prospects</span>
                {renderSortArrow('employ')}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortConfig.key === 'edu' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'edu' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("edu")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Premium education</span>
                {renderSortArrow('edu')}
              </div>
            </th>
            
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortConfig.key === 'econ' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'econ' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("econ")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Economic mobility</span>
                {renderSortArrow('econ')}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortConfig.key === 'liva' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'liva' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("liva")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>High livability</span>
                {renderSortArrow('liva')}

              </div>
            </th>
            

            {/* <th className={`text-right ${styles.cellHideMobile}`}>Investment <br/>migration options</th> */}
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
          // {sortedData.slice(0, numOfCitiesShow).map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow} ${styles.openedRow}`}>
                {/* <tr onClick={() => handleMobileRowClick(index)} className={`${styles.contentRow} ${index === display ? styles.openedRow : ''}`}> */}
                {/* <td>{item.city}</td> */}
                
                <td >
                  <div className="d-flex align-items-center">
                    <button className={styles.deleteRowButton} onClick={() => handleDeleteFromTable(item.country)}>
                      <IconDelete />
                    </button>
                    <CountryFlag country={item.country} code={item.ISO2} classname={styles.noMarginCountryFlag}/>
                    {item.im && ' *'}
                  </div>
                </td>
                {/* <td className={`text-left 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} />
                </td> */}
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'total' ? styles.percentColumn : ''}
                                ${sortConfig.key === 'total' ? styles.selectedColumn : ''}
                              `}>
                  <ProgressBar
                    percentValue={item.total > 0 ? item.total : 0}
                    labelText={formatNumberWithDot(item.total) + "%"}
                  />
                </td>

                <td className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortConfig.key ? styles.selectedColumn : ''} 
                                            ${sortConfig.key === 'total' ? styles.percentColumn : ''}
                                          `}>
                  {sortConfig.key === "total" ?
                    <ProgressBar
                      percentValue={item.total > 0 ? item.total : 0}
                      labelText={formatNumberWithDot(item.total) + "%"}
                    />
                    : formatNumberWithDot(item[sortConfig.key])
                  }
                </td>
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'project' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.project)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'career' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.career)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'employ' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.employ)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'edu' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.edu)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'econ' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.econ)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'liva' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.liva)}
                </td>
                

                {/* <td className={`text-right ${styles.cellHideMobile}`}>
                                  {item.link && (
                                      <a href={item.link} target="_blank" className={styles.linkText} rel="noreferrer">Find out more</a>
                                  )}
                                  
                              </td> */}
              </tr>
              {/* <tr className={`${styles.hiddenTableRow}`}>
                <td className={`${styles.countryMobileDiv}`}>
                  <CountryFlag country={item.country} />
                </td>
              </tr> */}

            </Fragment>
          ))}


        </tbody>
      </table>


      <div className="footer-note mt-5">
        {/* <ul>
          <li>Figures for June 2023.</li>
          <li>Only includes individuals living in each city (residents).</li>
          <li>'Centi-millionaires' refers to individuals with investable wealth of USD 100 million or more.</li>
        </ul> */}
        <p>*Country/territory with an investment migration offering</p>
      </div>
    </>
  )
}

export default Compare;